import { render, staticRenderFns } from "./HelpView.vue?vue&type=template&id=4a6654c0&scoped=true"
import script from "./HelpView.vue?vue&type=script&lang=ts"
export * from "./HelpView.vue?vue&type=script&lang=ts"
import style0 from "./HelpView.vue?vue&type=style&index=0&id=4a6654c0&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6654c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a6654c0')) {
      api.createRecord('4a6654c0', component.options)
    } else {
      api.reload('4a6654c0', component.options)
    }
    module.hot.accept("./HelpView.vue?vue&type=template&id=4a6654c0&scoped=true", function () {
      api.rerender('4a6654c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/HelpView.vue"
export default component.exports